import React from "react";
import EditButton from "@components/FlowActionButtons/EditButton";
import type { Task } from "@services/vesselCall/types";
import { paths } from "@utils/navigation";
import { useNavigate } from "react-router-dom";
import { canDiscardOrEditDraft } from "./utils";

interface EditDraftProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    originalVesselCallId?: string;
    task: Task | null;
    status: string;
  };
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const EditDraft: React.FC<EditDraftProps> = ({ vesselCallFlowData }) => {
  const navigate = useNavigate();

  if (!vesselCallFlowData) {
    return null;
  }
  const isActionAvailable = canDiscardOrEditDraft(vesselCallFlowData.status);
  const handleEditClick = () => {
    const { vesselCallId, originalVesselCallId } = vesselCallFlowData;
    const search = new URLSearchParams({
      prefillFromId: vesselCallId,
      finalSubmission: vesselCallFlowData.originalVesselCallId !== null ? "true" : "false",
      originalVesselCallId: originalVesselCallId ?? vesselCallId,
    });

    navigate(`/${paths.vesselCall.index}/create/pre-arrival-notification?${search.toString()}`, {
      state: {
        prefillFromId: vesselCallId,
        finalSubmission: vesselCallFlowData.originalVesselCallId !== null,
        originalVesselCallId: originalVesselCallId ?? vesselCallId,
      },
    });
  };

  return (
    <EditButton
      langBase={LANG_BASE}
      permission="canHandleVesselCallDraft"
      isActionAvailable={isActionAvailable}
      onClick={handleEditClick}
    />
  );
};
export default EditDraft;
